import { Chip } from "@material-ui/core";
import { green, grey } from "@material-ui/core/colors";
import PublicIcon from "@material-ui/icons/Public";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";

const STATUS_COLOR_MAP = {
	public: green[500],
	private: grey[500],
};
const STATUS_ICON_MAP = {
	public: PublicIcon,
	private: VisibilityOffIcon,
};

const VisibilityField = ({ source, record }) => {
	const translate = useTranslate();
	const status = get(record, source);
	const color = get(STATUS_COLOR_MAP, status, "");
	const statusLabel = translate(`resources.bookmakers.visibility.${status}`);
	const Icon = STATUS_ICON_MAP[status];
	return (
		<Chip
			icon={<Icon style={{ color: "white" }} />}
			label={statusLabel}
			style={{
				backgroundColor: color,
				color: "white",
			}}
		/>
	);
};
export default VisibilityField;
